import { Component, Inject, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ToastrService } from 'ngx-toastr';
import { ChatType, DefaultGUID, RoleName, SRGroupType } from 'src/app/@shared/constants/Constant';
import { ILoggedInUserViewModel } from 'src/app/model/common.model';
import { ICreateChatGroupModel, IGroupMemberModel, IOpenCreateNewGroupDialogPayload } from 'src/app/model/internalGroupChat.model';
import { VendorList } from 'src/app/service/customer.model';
import { IGetMemberViewModel, ViewMemberModel } from 'src/app/service/memeber.model';
import { VendorService } from 'src/app/service/vendor.service';
import { ChatListComponent } from '../../chat-list/chat-list.component';
import { InternalGroupChatService } from '../../internal-group-chat.service';

@Component({
  selector: 'app-create-new-group-dialog',
  templateUrl: './create-new-group-dialog.component.html',
  styleUrls: ['./create-new-group-dialog.component.css']
})
export class CreateNewGroupDialogComponent implements OnInit {
  public user: ILoggedInUserViewModel;
  public memberType: boolean = true;
  public groupName: string = null;
  public groupNameLength: number = 50;
  public groupNameLengthRemainingToShowOnUI: number = this.groupNameLength;
  public loader: boolean = false;
  public customerMemberLoader: boolean;
  public vendorLoader: boolean;
  public vendorMemberLoader: boolean;
  public isCreateGroupButtonDisabled: boolean;
  public internalMemberDataModel = {
    internalMemberList: this.data.internalMemberList,
    selectedInternalMemberList: [] as ViewMemberModel[],
    dropdownSetting: {
      singleSelection: false,
      itemsShowLimit: 2,
      idField: 'memberId',
      textField: 'name',
      allowSearchFilter: true,
      limitSelection: null
    },
  };
  public customerMemberDataModel = {
    customerMemberList: [] as IGetMemberViewModel[],
    selectedCustomerMemberList: [] as ViewMemberModel[],
    dropdownSetting: {
      singleSelection: false,
      itemsShowLimit: 2,
      idField: 'memberId',
      textField: 'name',
      allowSearchFilter: true,
      limitSelection: null
    },
  };

  public vendorDataModel = {
    vendorList: [],
    dropdownSetting: {
      displayKey: 'vendorName',
      search: true,
      placeholder: 'Select Vendor',
      height: '400px'
    },
    selectedVendor: { id: DefaultGUID, name: null } as VendorList,
  }; // reference in template file
  public vendorMemberDataModel = {
    vendorMemberList: [] as IGetMemberViewModel[],
    selectedVendorMemberList: [] as ViewMemberModel[],
    dropdownSetting: {
      singleSelection: false,
      itemsShowLimit: 2,
      idField: 'memberId',
      textField: 'name',
      allowSearchFilter: true,
      limitSelection: null
    },
  };
  public createGroupChatPayload: ICreateChatGroupModel;

  constructor(
    private _toast: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: IOpenCreateNewGroupDialogPayload,
    private _vendorService: VendorService,
    private _InternalGroupChatService: InternalGroupChatService,
    public dialogRef: MatDialogRef<ChatListComponent>
  ) { }

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('user'));
    this.createGroupChatPayload = {
      serviceRequestId: this.data.serviceRequest.serviceRequestId,
      chatGroupType: ChatType.group,
      serviceRequestGroupType: SRGroupType.custom,
      groupName: '',
      groupDescription: null,
      createdBy: this.user.memberId,
      groupMemberList: [],
    }
    this.internalMemberDataModel.internalMemberList = this.data.internalMemberList?.filter(internalMember => internalMember.memberId !== this.user.memberId && internalMember.role != null && internalMember.role !== RoleName.InternalReadOnly);
    this.checkSelectionLimit();
  }

  sliceExtraText(limitToShowText: number) {
    this.groupName = this.groupName ? this.groupName.slice(0, limitToShowText) : null;
    this.lengthToShowOnUI();
  }

  lengthToShowOnUI() {
    this.groupName = this.groupName ? this.groupName : '';
    this.groupNameLengthRemainingToShowOnUI = this.groupNameLength - this.groupName.length;
  }
  checkTotalMemberSelected(): number {
    let totalMemberSelected: number = this.internalMemberDataModel.selectedInternalMemberList.length +
      this.customerMemberDataModel.selectedCustomerMemberList.length +
      this.vendorMemberDataModel.selectedVendorMemberList.length;
    return totalMemberSelected;
  }

  checkSelectionLimit() {
    let totalMemberSelected: number = this.checkTotalMemberSelected();
    this.internalMemberDataModel.dropdownSetting.limitSelection = 19 - totalMemberSelected;
    this.customerMemberDataModel.dropdownSetting.limitSelection = 19 - totalMemberSelected;
    this.vendorMemberDataModel.dropdownSetting.limitSelection = 19 - totalMemberSelected;
  }

  radioButtonChange() {
    this.checkSelectionLimit();
    if (!this.memberType) {
      this.getCustomerMemberList();
      this.getVendorList();
    }
  }

  getCustomerMemberList() {
    this.customerMemberLoader = true
    this._vendorService.getMemberListByCustomerID(this.data.serviceRequest.customerBuId).subscribe(
      (response) => {
        this.customerMemberLoader = false;
        this.customerMemberDataModel.customerMemberList = response?.filter((customerMember) => customerMember.role != null);
      },
      (error) => {
        this.customerMemberLoader = false;
        console.log(error);
        this._toast.warning('Unable to get customer member List', 'Warning',
          {
            timeOut: 6000,
            positionClass: 'toast-top-center',
          });
      }
    )
  }

  getVendorList() {
    this.vendorLoader = true;
    this._vendorService.getFilteredVendorsList().subscribe(
      (response) => {
        this.vendorLoader = false;
        this.vendorDataModel.vendorList = response;
      },
      (error) => {
        this.vendorLoader = false;
        console.log(error);
        this._toast.warning('Unable to get vendor List', 'Warning',
          {
            timeOut: 6000,
            positionClass: 'toast-top-center',
          });
      }
    )
  }

  getVendorMemberList(vendor: VendorList): void {
    if (vendor.id !== DefaultGUID) {
      this.vendorMemberLoader = true;
      this._vendorService.getMemberListByCustomerID(vendor.id).subscribe(
        (response) => {
          this.vendorMemberLoader = false;
          this.vendorMemberDataModel.vendorMemberList = response?.filter((vendorMember) => vendorMember.role != null);
        },
        (error) => {
          this.vendorMemberLoader = false;
          console.log(error);
          this._toast.warning('Unable to get vendor member List', 'Warning',
            {
              timeOut: 6000,
              positionClass: 'toast-top-center',
            });
        }
      )
    }
  }

  groupMemberList(): IGroupMemberModel[] {
    let memberIDList: IGroupMemberModel[] = [];
    memberIDList.push(
      {
        isGroupAdmin: true,
        memberId: this.user.memberId
      }
    );
    this.internalMemberDataModel.selectedInternalMemberList.map((internalMember) => {
      memberIDList.push(
        {
          isGroupAdmin: false,
          memberId: internalMember.memberId
        }
      );
    });
    this.customerMemberDataModel.selectedCustomerMemberList.map((customerMember) => {
      memberIDList.push(
        {
          isGroupAdmin: false,
          memberId: customerMember.memberId
        }
      );
    });
    this.vendorMemberDataModel.selectedVendorMemberList.map((vendorMember) => {
      memberIDList.push(
        {
          isGroupAdmin: false,
          memberId: vendorMember.memberId
        }
      );
    });
    return memberIDList;
  }

  createGroup(formData: NgForm) {
    this.createGroupChatPayload.groupName = this.groupName ? this.groupName.trim() : null;
    this.createGroupChatPayload.groupMemberList = [];
    this.createGroupChatPayload.groupMemberList = this.groupMemberList();
    if (this.checkTotalMemberSelected() > 0 && this.groupName && this.groupName.trim().length > 0 && formData.valid) {
      this.loader = true;
      this.isCreateGroupButtonDisabled = true;
      this._InternalGroupChatService.createGroupChat(this.createGroupChatPayload).subscribe(
        (response) => {
          this.loader = false;
          this.isCreateGroupButtonDisabled = false;
          this.dialogRef.close(response.data);
          this._toast.success('New Group created successfully', 'Success',
            {
              timeOut: 6000,
              positionClass: 'toast-top-center',
            });
        },
        (error) => {
          this.loader = false;
          this.isCreateGroupButtonDisabled = false;
          console.log(error);
          this._toast.warning('Unable to create new group. Please try again later!', 'Warning',
            {
              timeOut: 6000,
              positionClass: 'toast-top-center',
            });
        }
      )
    }
    else {
      if (this.checkTotalMemberSelected() === 0) {
        this._toast.warning('Please select at least one Member!', 'Warning',
          {
            timeOut: 6000,
            positionClass: 'toast-top-center',
          });
      }
      if (this.groupName === null || this.groupName === '' || (this.groupName && this.groupName.trim().length === 0)) {
        this._toast.warning('Please enter Group Name!', 'Warning',
          {
            timeOut: 6000,
            positionClass: 'toast-top-center',
          });
      }
    }
  }

}
